var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel",style:(_vm.style)},[_c('div',{staticClass:"panel__wrapper"},[_c('h1',{style:(_vm.title_style)},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"panel__content"},[_vm._t("default",[_vm._v("Content")])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }